import { render, staticRenderFns } from "./SetAttribute.vue?vue&type=template&id=026cded0&scoped=true"
import script from "./SetAttribute.vue?vue&type=script&lang=js"
export * from "./SetAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026cded0",
  null
  
)

export default component.exports